import React, { useState, useEffect } from 'react';

import UserService from '../services/user.service';
import EventBus from '../common/EventBus';

const BoardUser = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    UserService.getUserBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);

        if (error.response && error.response.status === 403) {
          //401, ให้ logout เมื่อเจอ 403
          EventBus.dispatch('logout');
        }
      }
    );
  }, []);

  return (
    <div className="container">
      <header className="jumbotron">
        <h3>{content}</h3>
      </header>
    </div>
  );
};

export default BoardUser;
